import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JsonDataService } from './json-data.service';

import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ValidationService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(
    private http: HttpClient,
    private jsonDataService: JsonDataService,
  ) {}

  clubValidation(): Observable<any[]> {
    switch (environment.autoClub) {
      case 'W2C':
        return this.jsonDataService
          .getValidationJsonData()
          .pipe(map((validation) => validation.w2cvalidation));
      case 'RACV':
        return this.jsonDataService
          .getValidationJsonData()
          .pipe(map((validation) => validation.racvvalidation));
      case 'AANT':
        return this.jsonDataService
          .getValidationJsonData()
          .pipe(map((validation) => validation.aantvalidation));
      case 'RACQ':
        return this.jsonDataService
          .getValidationJsonData()
          .pipe(map((validation) => validation.racqvalidation));
      case 'RACT':
        return this.jsonDataService
          .getValidationJsonData()
          .pipe(map((validation) => validation.ractvalidation));
      case 'RAC':
        return this.jsonDataService
          .getValidationJsonData()
          .pipe(map((validation) => validation.racvalidation));
      case 'RAA':
        return this.jsonDataService
          .getValidationJsonData()
          .pipe(map((validation) => validation.raavalidation));
      default:
        return this.jsonDataService.getValidationJsonData();
    }
  }
}
